import Colors from "assets/Colors";
import styled from "styled-components";

const NoItemsContainer = styled.div`
  height: ${(props) => `${props.height}`};
  display: grid;
  align-items: center;
`;

const NoItemsMessageCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Title = styled.div`
  margin-top: 5px;
  text-align: center;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_secondary};
`;

export default {
  NoItemsContainer,
  NoItemsMessageCenter,
  Title,
};
